import OnboardingFirmes from './OnboardingFirmes';
import OnboardingFirmesPoc from './OnboardingFirmesPoC';
import OnboardingBase from './OnboardingBase';
import { useUser } from 'hooks/useUser/useUser';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';

const parseDate = (dateString) => {
    if (!dateString) return null;

    const parsedDate = new Date(dateString.replace(' ', 'T'));
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export default function Component(props) {
    const { layout, items } = props;
    const router = useRouter();
    const { isAuthenticated, loginState, loginStateTypes } = useUser();
    const [onboardingActiu, setOnboardingActiu] = useState(null);
    const onboardingSeleccionat = useRef(false);

    const isLoginStateResolved = loginState === loginStateTypes.AUTHENTICATED || loginState === loginStateTypes.GUEST;
    const isAuthenticationResolved = isLoginStateResolved && isAuthenticated !== null;

    useEffect(() => {
        if (router.query.no_onb !== undefined || !items || !isAuthenticationResolved || onboardingSeleccionat.current) return;
        const esOnboardingActiu = (item) => {
            if (!item.actiu) return false;

            const dataActual = new Date();

            const dataInici = parseDate(item.dataPublicacio);
            const dataFi = parseDate(item.dataDespublicacio);

            const estaActiu = (!dataInici || dataActual >= dataInici) && (!dataFi || dataActual <= dataFi);

            return estaActiu && (isAuthenticated ? item.usuarisLogats === true : item.usuarisNoLogats === true);
        };
        onboardingSeleccionat.current = true;
        setOnboardingActiu(items.find(esOnboardingActiu) || null);
    }, [items, isAuthenticationResolved, isAuthenticated, router.query.no_onb]);

    if (!items) return null;
    if (!isAuthenticationResolved || !onboardingSeleccionat.current) return null;

    if (onboardingActiu) {
        const audience = onboardingActiu.usuarisLogats ? 'logat' : onboardingActiu.usuarisNoLogats ? 'noLogat' : null;
        const onboardingKey = `onboarding_3catinfo_${onboardingActiu.id}_${audience}`;

        switch (onboardingActiu.tipus) {
            case 'component':
                return (
                    <OnboardingBase
                        key={onboardingKey}
                        onboardingActiu={onboardingActiu}
                        layout={layout}
                    />
                );
            case 'custom':
                return (
                    <OnboardingBase
                        key={onboardingKey}
                        onboardingActiu={onboardingActiu}
                        layout={layout}
                    />
                );
            case 'OnboardingFirmes':
                return (
                    !router.asPath.includes('firmes-poc') && (
                        <OnboardingFirmes key={onboardingActiu.id} {...props} onboardingActiu={onboardingActiu} layout={layout} />
                    )
                );
            case 'OnboardingFirmesPoC':
                return (
                    router.asPath.includes('firmes-poc') && (
                        <OnboardingFirmesPoc
                            key={onboardingActiu.id}
                            {...props}
                            onboardingActiu={onboardingActiu}
                            layout={layout}
                        />
                    )
                );
            default:
                return null;
        }
    }
}
